import { Article } from "@/interfaces/Product";
import React from "react";

interface ProductProps {
  product: Article;
  scannedQuantity?: number;
}
const Product: React.FC<ProductProps> = ({ product, scannedQuantity }) => {
  return (
    <div className="group relative overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm mt-3">
      <div className="flex items-center gap-4 p-4">
        <div className="relative h-20 w-20 flex-shrink-0 overflow-hidden rounded-md bg-gray-100">
          <img
            src={product.image || "/placeholder.svg"}
            alt={product.articleName}
            className="h-full w-full object-cover"
          />
        </div>
        <div className="flex flex-1 flex-col gap-1">
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-gray-900">{product.genCode}</h3>
            <span className="text-sm font-medium text-gray-600">
              <span>Qté: </span>
              {scannedQuantity !== undefined
                ? `${scannedQuantity}/${product?.quantity ?? 1}`
                : `${product?.quantity ?? 1}`}
            </span>
          </div>
          <p className="text-sm text-gray-600 line-clamp-2">
            {product.articleName}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Product;
